// extracted by mini-css-extract-plugin
export default {"NotSupportedPage":"NotSupportedPage_NotSupportedPage__zknle"};